<template>
  <div>
    <b-message type="is-danger" v-if="!(modulus > 1 && modulus <= 25)">
    Bitte wähle einen Modulus zwischen 1 und 25.
    </b-message>
    <div class="columns" v-if="modulus > 1 && modulus <= 25">
      <div class="column is-narrow">
        <ModularCircle :num="firstSum" :modulus="modulus" />
      </div>
      <div class="column">
       <div class="box" style="width:20em;">
         <b-field :label="mode == 'sub' ? 'Minuend' : 'Erster Summand'">
           <b-input type="number" v-model.number="firstSum" @change="reset" />
         </b-field>
         <b-field :label="mode == 'sub' ? 'Subtrahend' : 'Zweiter Summand'">
           <b-input type="number" v-model.number="secondSum" />
         </b-field>
         <button class="button is-primary" @click="startAddition">Ausrechnen</button>
       </div>
       <div class="box" style="width:20em;" v-if="origFirstSum !== null">
       <p :style="{'font-weight': result !== null ? 'bold' : 'normal'}">
       {{ origFirstSum }}
       <span v-if="origSecondSum >= 0">{{ plusSymbol }}</span>
       <span v-else>{{ minusSymbol }}</span>
       {{ Math.abs(origSecondSum) }} =
       <span v-if="result !== null">{{ result }}</span>
       <span v-else>?</span>
       &nbsp;&nbsp;(mod {{ modulus }})
       </p>
       </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModularCircle from '@/components/ModularCircle.vue'

export default {
  components: {
    ModularCircle
  },
  props: ['modulus', 'mode'],
  data() {
    return {
      num: 0,
      firstSum: 0,
      secondSum: 0,
      animation: null,
      origFirstSum: null,
      origSecondSum: null,
      result: null
    }
  },
  computed: {
    minusSymbol() {
      return this.mode == 'sub' ? '+' : '-'
    },
    plusSymbol() {
      return this.mode == 'sub' ? '-' : '+'
    }
  },
  methods: {
    startAddition() {
      this.reset()
      let expected = mod(this.firstSum, this.modulus);
      this.animation = window.setInterval(function() {
        if (this.firstSum > expected) {
          this.firstSum -= 1
        } else if (this.firstSum < expected) {
          this.firstSum += 1
        } else {
          this.reset()
          this.startRealAddition()
        }
      }.bind(this), 50)
    },
    startRealAddition() {
      this.reset()
      this.result = null
      this.origFirstSum = this.firstSum
      this.origSecondSum = this.secondSum
      this.animation = window.setInterval(function() {
        if (this.secondSum == 0) {
          this.reset()
          this.result = this.firstSum
        } else {
          let direction = this.secondSum >= 0 ? 1 : -1
          this.secondSum -= direction
          this.firstSum = mod(this.firstSum + direction * (this.mode == 'sub' ? -1 : 1), this.modulus)
        }
      }.bind(this), 500);
    },
    reset() {
      if (this.animation !== null) {
          window.clearInterval(this.animation);
      }
    }
  }
}

function mod(a, m) {
  let x = a % m
  while (x < 0) {
    x += m
  }
  return x
}
</script>
